import { render, staticRenderFns } from "./BaseVideo.vue?vue&type=template&id=58527ba6&scoped=true&"
import script from "./BaseVideo.vue?vue&type=script&lang=ts&"
export * from "./BaseVideo.vue?vue&type=script&lang=ts&"
import style0 from "./BaseVideo.vue?vue&type=style&index=0&id=58527ba6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58527ba6",
  null
  
)

export default component.exports